/* dermaliss motion layer - scroll choreography, applied automatically to every template */
(function(){
var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if(reduce||!('IntersectionObserver' in window)){document.documentElement.classList.add('no-motion');return;}
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
var bar=null,par=[],ticking=false,io=null,wide=window.innerWidth>900;

var GROUPS=[
['m-head','.page-head h1,.h-sec,.pinfo h1,.stage-in h2,.split-copy h2,.ugc-head h2,.empty h1,.claim-panel h2'],
['m-media','.gallery .shot,.pcard-in,.ugc-tile,.post .thumb,.summary'],
['m-up','.page-head p,.split-copy p,.stage-in p,.pcard-desc,.pcard-meta,.eyebrow,.tax-note,.price-line,.buy-row,.opt,.trust>div,.acc details,.foot-grid>div,.card-info,.line,.form,.ugc-pill,.split-copy .btn,.stage-in .btn,.spec-row,.gallery .thumbs']
];
var SKIP='.nav,.mnav,.cd,.cd-scrim,.ticker,.m-bar,.amb,.sbuy';

function tag(){
GROUPS.forEach(function(g){
$$(g[1]).forEach(function(el){
if(el.dataset.m||el.classList.contains('rise')||el.closest(SKIP))return;
el.dataset.m=g[0];
});
});
var seen=[],counts=[];
$$('[data-m]').forEach(function(el){
var p=el.parentNode,i=seen.indexOf(p);
if(i<0){seen.push(p);counts.push(0);i=seen.length-1;}
el.style.setProperty('--d',Math.min(counts[i],5)*70+'ms');
counts[i]++;
});
}

function show(el){
el.classList.add('in');
if(io)io.unobserve(el);
setTimeout(function(){el.style.removeProperty('--d');},1600);
}

function observe(){
io=new IntersectionObserver(function(es){
es.forEach(function(e){if(e.isIntersecting)show(e.target);});
},{threshold:0,rootMargin:'0px 0px -6% 0px'});
$$('[data-m]').forEach(function(el){
if(el.getBoundingClientRect().top<window.innerHeight){show(el);return;}
io.observe(el);
});
}

/* safety net: nothing may stay hidden, whatever happens with the observer */
function sweep(){
$$('[data-m]:not(.in)').forEach(function(el){
if(el.getBoundingClientRect().top<window.innerHeight*1.1)show(el);
});
}

function collect(){
par.forEach(function(p){p.el.style.transform='';p.el.removeAttribute('data-par');});
par=[];
if(!wide)return;
var add=function(sel,amt,axis){
$$(sel).forEach(function(el){
if(el.closest(SKIP))return;
el.setAttribute('data-par','');
par.push({el:el,amt:amt,axis:axis||'y'});
});
};
add('.split-art',8);
add('.hero-in',-12);
add('.wordmark',20,'x');
add('.claim-art',7);
}

function frame(){
ticking=false;
var doc=document.documentElement;
if(bar){
var max=doc.scrollHeight-doc.clientHeight;
bar.style.transform='scaleX('+(max>0?doc.scrollTop/max:0)+')';
}
var vh=window.innerHeight;
for(var i=0;i<par.length;i++){
var p=par[i],r=p.el.getBoundingClientRect();
if(r.bottom<-200||r.top>vh+200)continue;
var prog=(r.top+r.height/2-vh/2)/vh;
if(prog>1)prog=1;if(prog<-1)prog=-1;
var v=(prog*p.amt).toFixed(2);
p.el.style.transform=p.axis==='x'?'translate3d('+v+'%,0,0)':'translate3d(0,'+v+'%,0)';
}
}

function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(frame);}}

var rt;
function onResize(){
clearTimeout(rt);
rt=setTimeout(function(){wide=window.innerWidth>900;collect();onScroll();sweep();},180);
}

function start(){
bar=document.querySelector('.m-bar');
tag();observe();collect();frame();
window.addEventListener('scroll',onScroll,{passive:true});
window.addEventListener('resize',onResize,{passive:true});
window.addEventListener('load',function(){sweep();setTimeout(sweep,900);});
setTimeout(sweep,2500);
document.addEventListener('shopify:section:load',function(){tag();observe();collect();frame();});
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);
else start();
})();